import { EXTRAS_TYPE, PRODUCT } from '@ahmdigital/constants';
import { some } from 'lodash/fp';

import { ProductType } from '../../types/product';

const hasChoosable60Products = (products: ProductType[]) =>
  some(
    (product: ProductType) => product.extrasType === EXTRAS_TYPE.CHOOSABLE && product.id !== PRODUCT.CHOOSABLE_50_TEETH,
    products,
  );

export default hasChoosable60Products;
